import React from 'react';
import { useConnect } from '@lore/query-connect';
import { offer_networkId } from '../../../../utils/query-helpers';

export default function useClaims(state, network, schoolStart, schoolEnd, extra = {}) {
  return useConnect('claim.find', {
    where: {
      eager: {
        $where: {
          // ...offer_networkId(network),
          offer: {
            $where: {
              creator: {
                $where: {
                  state: {
                    $ilike: state
                  }
                }
              }
            }
          },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          ...extra
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });
}
